import { apiSlice } from './baseApi';

// Side-effect imports: each injectEndpoints augments apiSlice
import './orderApi';
import './financeApi';
import './customerApi';
import './invoiceApi';
import './serviceItemApi';
import './expenseApi';
import './investmentApi';
import './userApi';
import './companyApi';
import './serviceTypeApi';
import './accountCodeApi';
import './serviceCompanyApi';
import './expenseCategoryApi';
import './investmentCategoryApi';
import './subscriptionApi';

export { apiSlice };

export const {
  useGetPlanUsageQuery,
  useGetPlanCatalogQuery,
  useGetServiceTypesQuery,
  useGetAccountCodesQuery,
  useGetOrdersQuery,
  useGetOwedToUsQuery,
  useGetWeOweQuery,
  useGetOrderQuery,
  useGetUserOrdersQuery,
  useGetServiceCompaniesQuery,
  useGetUsersQuery,
  useGetUsersListQuery,
  useGetExpenseCategoriesQuery,
  useGetInvestmentCategoriesQuery,
  useGetCustomersQuery,
  useGetUserCustomersQuery,
  useGetInvoicesQuery,
  useGetInvoicesByUsersQuery,
  useGetExpensesQuery,
  useGetInvestmentsQuery,
  useGetCompanyByIdQuery,
  useGetServiceItemsQuery,
  useGetServiceItemsByOperatorQuery,
  useLazyGetServiceTypesQuery,
  useLazyGetAccountCodesQuery,
  useGetExpenseCategoriesListQuery,
  useGetInvestmentCategoriesListQuery,
  useGetServiceTypesListQuery,
  useGetServiceCompaniesListQuery,
  useGetAccountCodesListQuery,
  useGetAccountCodeAmountsQuery,
  useAddExpenseCategoryMutation,
  useEditExpenseCategoryMutation,
  useDeleteExpenseCategoryMutation,
  useAddInvestmentCategoryMutation,
  useEditInvestmentCategoryMutation,
  useDeleteInvestmentCategoryMutation,
  useAddServiceTypeMutation,
  useEditServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useAddServiceCompanyMutation,
  useEditServiceCompanyMutation,
  useDeleteServiceCompanyMutation,
  useAddAccountCodeMutation,
  useEditAccountCodeMutation,
  useDeleteAccountCodeMutation,
  useChangeOrderPayStatusMutation,
  useDeleteOrderMutation,
  useChangeOrderDateMutation,
  useDeleteServiceItemMutation,
  useChangeServiceStatusMutation,
  useChangeCustomerStatusMutation,
  useDeleteCustomerMutation,
  useToggleCustomerBotStatusMutation,
  useChangeInvoicePayStatusMutation,
  useDeleteInvoiceMutation,
  useChangeInvoiceDateMutation,
  useEditInvoiceSimpleMutation,
  useDeleteExpenseMutation,
  useDeleteInvestmentMutation,
  useAddCustomerMutation,
  useEditCustomerMutation,
  useAddOrderMutation,
  useAddServiceToOrderMutation,
  useAddExpenseMutation,
  useEditExpenseMutation,
  useAddInvestmentMutation,
  useEditInvestmentMutation,
  useAddInvoiceMutation,
  useEditInvoiceMutation,
  useUpdateInvoiceWizardMutation,
  useAddUserMutation,
  useRenewStaffInviteMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useSetUserAccessStatusMutation,
  useAddServiceItemMutation,
  useEditServiceItemMutation,
  useGetCalendarEventsQuery,
  useGetSubscriptionStatusQuery,
  useGetSubscriptionPlansQuery,
  useLazyGetSubscriptionUpgradeQuoteQuery,
  useGetSubscriptionPaymentsQuery,
  useInitiateSubscriptionMutation,
  useChangeSubscriptionPlanMutation,
  useReconcileSubscriptionCheckoutMutation,
  useCancelSubscriptionMutation,
  useRetrySubscriptionMutation,
  useUpdateSubscriptionCardMutation,
} = apiSlice;
